import React from 'react';

import { createRoot } from 'react-dom/client';
import './index.scss';
import { SnackbarProvider } from 'notistack';

import App from './App';
import { SnackbarUtilsConfigurator } from './common/utils/SnackbarUtilsConfigurator';

function Main() {
  return (
    <SnackbarProvider maxSnack={3}>
      <SnackbarUtilsConfigurator />
      <App />
    </SnackbarProvider>
  );
}

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
root.render(<Main />);
